var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnter = function SvgEnter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fb4a59;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0ZM10.56,16.33a1,1,0,0,1,0-1.41l.92-.92H6.89a1,1,0,0,1,0-2h4.59l-.92-.92A1,1,0,0,1,12,9.67l2.63,2.62a.21.21,0,0,0,0,.06,1,1,0,0,1,.17.27,1,1,0,0,1,0,.76,1,1,0,0,1-.17.27.21.21,0,0,0,0,.06L12,16.33a1,1,0,0,1-1.41,0ZM18.89,18a1.47,1.47,0,0,1-.43,1.05,1.48,1.48,0,0,1-1.07.45h-4.5a1,1,0,0,1,0-2h4v-9h-4a1,1,0,0,1,0-2h4.5a1.47,1.47,0,0,1,1.06.44A1.52,1.52,0,0,1,18.89,8Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Enter.b32f9a47.svg";
export { ForwardRef as ReactComponent };